import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { GematikTourCallbacks, GematikTourState, GematikTourStep } from "../models/gematik-tour.model";

@Injectable({ providedIn: "root" })
export class GematikTourService {
  private state$ = new BehaviorSubject<GematikTourState>({
    active: false,
    currentStep: 0,
    steps: [],
  });

  private callbacks: GematikTourCallbacks = {};

  readonly tour$ = this.state$.asObservable();

  get state(): GematikTourState {
    return this.state$.value;
  }

  start(steps: GematikTourStep[], callbacks: GematikTourCallbacks = {}): void {
    this.callbacks = callbacks;
    this.state$.next({ active: true, currentStep: 0, steps });
  }

  next(): void {
    const s = this.state$.value;
    if (s.currentStep < s.steps.length - 1) {
      this.state$.next({ ...s, currentStep: s.currentStep + 1 });
    } else {
      this.callbacks.completeCallback?.();
      this.end();
    }
  }

  prev(): void {
    const s = this.state$.value;
    if (s.currentStep > 0) {
      this.state$.next({ ...s, currentStep: s.currentStep - 1 });
    }
  }

  skip(): void {
    this.callbacks.skipCallback?.();
    this.end();
  }

  end(): void {
    this.callbacks = {};
    this.state$.next({ active: false, currentStep: 0, steps: [] });
  }
}
